import type { ReactNode } from 'react';

import { Field } from '@/shared/ui/Field';
import { Icon } from '@/shared/ui/Icon';

/**
 * Barra de busca e filtro das listagens de cadastro.
 *
 * Ela existe para que corretores, tomadores e operacoes tenham a mesma disposicao
 * e o mesmo comportamento. Sem um componente comum, cada modulo escolhe uma altura
 * e uma ordem diferentes, e a plataforma passa a parecer varios produtos.
 */
export function PartyToolbar({
  search,
  onSearch,
  placeholder,
  filter,
  extra,
}: {
  search: string;
  onSearch: (value: string) => void;
  placeholder: string;
  filter?: ReactNode | undefined;
  extra?: ReactNode | undefined;
}) {
  return (
    <div className="flex flex-col gap-3 border-b border-line px-5 py-3.5 md:flex-row md:items-end">
      <div className="flex-1">
        <Field
          label="Buscar"
          className="h-9"
          placeholder={placeholder}
          value={search}
          leading={<Icon name="target" size={15} />}
          onChange={(event) => onSearch(event.target.value)}
        />
      </div>
      {filter ? <div className="w-full md:w-56">{filter}</div> : null}
      {extra ? <div className="w-full md:w-56">{extra}</div> : null}
    </div>
  );
}
